"use client";

import { Box, Button, Image, Stack, Typography, Video } from "components";
import { withContent } from "contexts/content";
import { useMedia } from "hooks";

function PartnerTestimonials({ redirect }) {
  const { laptop } = useMedia();
  const people = [
    ["4.jpeg", 3.2, 0, -1],
    ["14.jpeg", 4.1, 0, -2],
    ["13.jpeg", 3.2, 4, 2],
    ["0.jpeg", 5, -1, -5],
    ["2.jpeg", 3.5, 6, 5],
    ["6.jpeg", 4.1, 0, -1],
    ["8.jpeg", 3.5, -22, 3],
    ["5.jpeg", 4.5, -15, 5],
    ["3.jpeg", 4.1, -5, 2],
    ["7.jpeg", 3.2, 8, -3],
    ["11.jpeg", 4.5, -2, 3],
    ["9.jpeg", 4.1, 23, 3],
    ["12.jpeg", 6, -2, 1],
    ["10.jpeg", 3.5, -1, 5],
    ["4.jpeg", 5, 14, 5, !laptop],
    ["8.jpeg", 3.5, 11, 0, !laptop],
    ["15.jpeg", 4.5, 8, 7],
    ["1.jpeg", 5, 3, -1],
  ];

  return (
    <Stack className="BupDivider-bottom" component="section">
      <Stack spacing={2}>
        <Box className="BupPartner-avatars">
          {people.map(([url, size, mx, my, show], i) => (
            <div key={i}>
              {url && (
                <Image
                  alt={`person-${i}`}
                  style={{
                    marginLeft: `${10 * mx}px`,
                    marginTop: `${10 * my}px`,
                  }}
                  src={
                    !show
                      ? typeof url === "string"
                        ? "avatars/" + url
                        : `assets/discover-2.webp`
                      : null
                  }
                  height={20 * size}
                  width={20 * size}
                />
              )}
            </div>
          ))}
        </Box>
      </Stack>
      <Typography variant="h3">
        <center>Muchas personas felices</center>
      </Typography>
      <Stack spacing={2}>
        <Typography className="Bup-subtitle" variant="span">
          <center>¡Forma parte de esta gran comunidad hoy!</center>
        </Typography>
        <Typography className="Bup-info">
          Estamos felices de ver miles de personas felices que han usado{" "}
          <b>BondUP</b> para conectar con nuevos amigos y explorar sus
          intereses. ¿Eres el próximo?
        </Typography>
        <Stack
          flexDirection="row"
          justifyContent="center"
          spacing={2}
          useFlexGap
          hidden
        >
          {[
            "https://drive.google.com/file/d/1FAyiV8HfpfzIU8vRytgj5DQZ8A6gT0se/preview",
            "https://drive.google.com/file/d/1b1gWcfNN6Mgaseh1pZHST3sJgxx7dhQi/preview",
            "https://drive.google.com/file/d/1iN5pUGBzRcyXjj5qmmpt9FYsOZNJVjOo/preview",
            "https://drive.google.com/file/d/1GX5xcfzdXwOar4TnG13yRZCIHBGnwsO9/preview",
            "https://drive.google.com/file/d/1nxBbhxvmkUfLVjXZ1Ce0Txv3JI5tvQZr/preview",
          ].map((src, i) => (
            <Video
              key={i}
              className="BupVideo-reel"
              src={src}
              width="640"
              height="480"
            />
          ))}
        </Stack>
        <center>
          <Button
            id="BB-register-4"
            className="BupButton-wide BupButton-dark"
            color="inherit"
            onClick={() => redirect.register({ params: { signUpCode: "BCH" } })}
            size="large"
            sx={{ mt: 10 }}
            variant="text"
          >
            Acceder al beneficio
          </Button>
        </center>
      </Stack>
    </Stack>
  );
}

export default withContent(PartnerTestimonials);
